"use strict";
import CartModalController from "emun.cart/cart-modal.controller.es6";
import modals from "webmodals/modals";
import template from "emun.cart/shipping-location-prompt.htm";
import customerConfig from "emun.customer/customer.config";

class ShippingLocationPromptController extends CartModalController {
  constructor($session, $cart, $geo, $uibModalInstance, options) {
    "ngInject";
    super($session, $cart, $uibModalInstance, options);
    let $ctrl = this;
    $ctrl.customerConfig = customerConfig;
    $ctrl.$geo = $geo;
    if ($ctrl.request) {
      if (
        $ctrl.request.personName &&
        $ctrl.request.personName.full == "Guest"
      ) {
        $ctrl.request.personName.full = "";
      }
      $ctrl.prompt[$ctrl.request.id ? "editing" : "creating"].notify($ctrl);
    }
  }

  submit() {
	  let $ctrl = this;
    if ($ctrl.request.address && $ctrl.request.address1 != $ctrl.request.address) $ctrl.request.address1 = $ctrl.request.address;
    return $ctrl.$cart
      .applyShippingLocation({ update: true, ...$ctrl.request })
      .then((res) => {
        $ctrl.prompt[$ctrl.request.id ? "edited" : "created"].notify(res);
        $ctrl.$cart.load();
        $ctrl.$close(res);
      });
  }
}

export function ShippingLocationPromptFactory($q) {
  "ngInject";
  class ShippingLocationPrompt {
    constructor() {
      var me = this;
      //promises
      ["editing", "creating", "edited", "created"].forEach((k) => {
        me[k] = $q.defer();
        me[k].on = me[k].subscribe = me[k].sub = (cb) =>
          me[k].promise.finally(null, cb);
      });
    }
    open(options) {
      let prompt = this;
      let modalInstance = (prompt.modal = modals.open({
        size: "md",
        templateUrl: template,
        controller: ShippingLocationPromptController,
        bindToController: true,
        controllerAs: "$ctrl",
        resolve: {
          options: () => angular.extend({ prompt }, options),
        },
      }));

      return modalInstance.result;
    }
  }
  return ShippingLocationPrompt;
}

export function ShippingLocationPromptDirectiveFactory(
  ShippingLocationPrompt,
  $parse
) {
  return {
    restrict: "EA",
    scope: false,
    link: function (scope, element, attr) {
      var prompt = new ShippingLocationPrompt();
      attr.onEdited &&
        me.edited.subscribe((args) => $parse(attr.onEdited)(scope, args));
      attr.onCreated &&
        me.created.subscribe((args) => $parse(attr.onCreated)(scope, args));
      attr.ngModel && $parse(attr.ngModel).assign(scope, prompt);

      var $targets = attr.clickSelector
        ? element.find(attr.clickSelector)
        : element;
      $targets.on("click", (e) =>
        prompt.open({
          title: attr.title,
          request: scope.$eval(attr.shippingLocation),
        })
      );
    },
  };
}
